export default __webpack_public_path__ + "static/media/2324 knife block A side.56375d23.png";